import { brandConfigObjectMap } from "@/brand/brandConfig";

const DEFAULT_BRAND = "blg-singtel-en";

export const brandConfigMap = new Map([
  ["http://localhost:8080", getBrandConfig(DEFAULT_BRAND)],
  ["http://localhost:8081", getBrandConfig(DEFAULT_BRAND)],
  ["http://sg-play.blg.gg", getBrandConfig(DEFAULT_BRAND)],
  ["https://sg-play.blg.gg", getBrandConfig(DEFAULT_BRAND)],
  ["default", getBrandConfig(DEFAULT_BRAND)],
]);

export function getBrandConfig(brand = DEFAULT_BRAND) {
  const brandConfigObject = brandConfigObjectMap.get(brand);
  return {
    brand,
    ...brandConfigObject,
  };
}

export function getDefaultBrandConfig() {
  return getBrandConfig(DEFAULT_BRAND);
}
